export { BlockSharedModule } from './src/module';
export { BlockGroupComponent } from './src/component/group/group';
export {
  getBlockConfig,
  getBlockContentGroupId,
  registerContentComponents,
  makeColoredBackgroundContainerProvider,
  ColoredBackgroundContainer,
} from './src/helpers';
export { BuildContentComponent } from './src/component/build-content/build-content';
export { StepContentElementDirective } from './src/directive/step-content-element';
export { IStepContentChildOffset, BlocksContentPreformatter } from './src/interface';
